import { usePath } from "../libs/path/PathProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import { Price } from "../models/Price";
import PortUtils from "../portlibs/PortUtils";
import Table from "../gui/Table/Table";
import DividendsToolbar from "../components/dividends/DividendsToolbar";

type TDividendRow = {
    id:string
    name:string
    price?:Price
    history:Record<string,number>
    total:number
}

function cellRenderer(row:TDividendRow, col:string) {
    if (col=="name") return row.name
    else return PortUtils.formatCurrency(row.price?.currency || 0, row.history[col])
}
function cellValue(row:TDividendRow, col:string) {
    if (col=="name") return row.name
    else return row.history[col]
}
export default function(){
    const {query} = usePath();
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const year = new Date().getFullYear()
    const first = year - 5
    const cols : string[] = ["name"]
    for(let i=first; i<=year; i++) cols.push(i.toString())
    const holdings = portfolio.filter(currency, filter, account, true).filter(holding => !PortUtils.isZero(holding.quantity) || holding.ytd_payout>0)
    const footer : TDividendRow = {id:"",name:"",history:{},total:0}
    const rows = holdings.map(holding => {
        const div = holding.dividendHistory
        const cell : TDividendRow = {
            id:holding.id,
            name:holding.name,
            price:holding.price,
            history:{},
            total:0
        }
        const exchange = holding.exchange
        for(let i=first; i<=year; i++) {
            const a = div.dividendOnYear(i)
            cell.history[i] = a
            cell.total += a
            footer.history[i] = (footer.history[i]||0) + a*exchange
            footer.total += a
        }
        return cell
    })    
    for(var i=rows.length-1; i>=0; i--) {
        if (PortUtils.isZero(rows[i].total)) rows.splice(i, 1)
    }
    return <>
        <DividendsToolbar/>
        <div id="dhistory" className="flex1 scroller">
            <Table rows={rows} tableName="dhistory" cols={cols} cellText={cellRenderer} cellValue={cellValue} footer={[footer]} rowKey={r => r.id}/>
        </div>    
    </>
}